import { Card, Row, Col } from 'react-bootstrap'
import Colors from '../../../../constants/Colors'
import { getBankFullNameByBankName, getTHBirthDay } from '../../utils'
import PropTypes from 'prop-types'

const UserDetailCard = ({ userData }) => {
  return (
    <Card
      style={{
        width: '100%',
        borderWidth: '1px',
        borderColor: Colors.BLACK,
      }}
    >
      <h4 className="px-3 pt-3">ข้อมูลลูกค้า</h4>
      <Row
        className="p-3"
        style={{
          width: '100%',
        }}
      >
        <Col xs={6}>
          <div>ชื่อ: {userData?.firstName}</div>
          <div>นามสกุล : {userData?.lastName}</div>
          <div>วัน/เดือน/ปี เกิด : {userData?.birthDay ? getTHBirthDay(userData?.birthDay) : '-'}</div>
        </Col>
        <Col xs={6}>
          <div>ธนาคาร : {userData?.bankName ? getBankFullNameByBankName(userData?.bankName) : '-'}</div>
          <div>เลขที่บัญชี : {userData?.bankNo || '-'}</div>
        </Col>
      </Row>
    </Card>
  )
}

UserDetailCard.propTypes = {
  userData: PropTypes.shape({
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    birthDay: PropTypes.string,
    bankName: PropTypes.string,
    bankNo: PropTypes.string,
  }),
}

export default UserDetailCard
